import { Flex } from '@televet/kibble-ui';
import { Link } from '@televet/kibble-ui/build/components/Link';
import React from 'react';

const LearnAboutServiceRemindersLink = (): JSX.Element => (
  <Flex flex={1} justifyContent="flex-end">
    <Link
      href="https://help.otto.vet/hc/en-us/articles/36493313479693-Getting-Started-on-Otto-Service-Reminders-for-ezyVet-A-Step-by-Step-Guide"
      isExternal={true}
    >
      Learn about Service Reminders here!
    </Link>
  </Flex>
);

export default LearnAboutServiceRemindersLink;
